import { inject, Injectable, OnDestroy } from '@angular/core';
import { ApiService } from '../service/api.service';
import { bufferTime, catchError, EMPTY, filter, forkJoin, map, Subject, switchMap } from 'rxjs';
import { MD5 } from 'crypto-js';
import { AccountService } from '../service/account.service';

export enum WeblogEndpoint {uiError, marketRestError, marketWsError}

@Injectable({
  providedIn: 'root'
})
export class WebLoggerService implements OnDestroy {

  private api = inject(ApiService)
  private account = inject(AccountService)
  private errorSubject = new Subject<{url: string, error: any}>()
  private isBlocked = false
  private hashes: string[] = []

  constructor() {
    this.errorSubject.pipe(
      bufferTime(10_000),
      filter(errors => errors.length > 0),
      switchMap(errors => {
        if (this.isBlocked) {
          return EMPTY
        }
        // Разбиваем ошибки по урлам
        const errorsMap: Record<string, any[]> = {}
        errors.forEach(e => {
          if (errorsMap[e.url] === undefined) {
            errorsMap[e.url] = []
          }
          errorsMap[e.url].push(e.error)
        })
        // Отправляем каждую категорию ошибок на свой урл
        return forkJoin(Object.entries(errorsMap).map(([url, errors]) => this.api.post(url, {errors})))
      }),
      catchError(() => {
        this.isBlocked = true
        setTimeout(() => this.isBlocked = false, 60_000)
        return EMPTY
      })
    ).subscribe()
  }

  ngOnDestroy(): void {
    this.errorSubject.complete()
  }

  /**
   * Форматирует и прокидывает ошибку дальше, если такой еще не зарегистрировано
   */
  reportError(endpoint: WeblogEndpoint, error: any) {
    this.formatError(error).subscribe(obj => {
      if (Object.keys(obj).length > 1) {
        const hash = MD5(JSON.stringify(obj)).toString()
        if (!this.hashes.includes(hash)) {
          this.errorSubject.next({
            url: this.resolveEndpoint(endpoint),
            error: obj
          })
          this.hashes.push(hash)
          if (this.hashes.length > 1000) {
            this.hashes.shift()
          }
        }
      }
    })
  }

  private formatError(error: any) {
    return this.account.getProfile().pipe(
      map(profile => profile && typeof error == 'object' && error ? {accId: profile.id, ...error} : error)
    )
  }

  private resolveEndpoint(endpoint: WeblogEndpoint) {
    switch (endpoint) {
      case WeblogEndpoint.uiError: return '/weblog/log-errors'
      case WeblogEndpoint.marketRestError: return '/weblog/market-rest-errors'
      case WeblogEndpoint.marketWsError: return '/weblog/market-ws-errors'
    }
  }

}
